import { createContext, useContext } from 'react';

export const TileFillContext = createContext(false);

export function useTileFill(): boolean {
  return useContext(TileFillContext);
}
